<template>
  <div>
    <a-radio-group v-model="templateId" class="form-item-template" name="radioGroup">
      <a-card v-for="(template, index) in workflowTemplates" v-show="extend === true || index < maxNumber" :key="template.id" class="template-card">
        <span>
          <a-radio :value="template.id" style="margin-left: 3px">
            <span class="template-card-title">{{ template.name }}</span>
          </a-radio>
        </span>
        <div class="template-card-content">
          <a-steps class="template-card-steps" size="small" :current="null" :style="{ width: `${template.steps.length * 140}px` }">
            <a-step v-for="step in template.steps" :key="step.id" :title="step.name" />
          </a-steps>
        </div>
      </a-card>
      <div v-if="workflowTemplates.length > maxNumber" class="extend-button" @click="extend = !extend">
        <span class="extend-button_text">{{ extend === false ? '查看更多' : '折叠更多' }}</span>
        <a-icon :type="extend === false ? 'down' : 'up'" />
      </div>
    </a-radio-group>
  </div>
</template>
<script>
import { workflowTemplateList } from '@/api/project/workflow';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      extend: false,
      maxNumber: 4,
      templateId: null,
      workflowTemplates: [],
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  watch: {
    value() {
      this.templateId = this.value;
    },
    templateId() {
      for (let i = 0; i < this.workflowTemplates.length; i++) {
        if (this.workflowTemplates[i].id === this.templateId) {
          this.$emit('change', this.templateId);
          this.$emit('onFocus', this.workflowTemplates[i]);
          break;
        }
      }
    }
  },
  created() {
    this.templateId = this.value;
    this.getWorkflowTemplateList();
  },
  methods: {
    getWorkflowTemplateList() {
      workflowTemplateList({ status: 0, project_id: this.projectId }).then(res => {
        this.workflowTemplates = res.data.items;
      });
    }
  }
};
</script>
<style lang="less">
.template-card {
  .ant-card-body {
    padding: 10px 10px 4px 10px;
  }
}
</style>

<style lang="less" scoped>
.form-item-template {
  width: 100%;
}

.template-card {
  margin: 3px 0;

  .template-card-title {
    display: inline-block;
  }

  .template-card-content {
    overflow: auto;
    padding: 8px 0;

    .template-card-steps {
      margin-bottom: 8px;
    }
  }
}
.extend-button {
  width: 100%;
  text-align: center;
  cursor: pointer;
  line-height: 32px;
  .extend-button_text {
    padding-left: 8px;
  }
}

.extend-button:hover {
  color: #1890ff;
}
</style>
